import type { $Fetch } from 'ofetch';
import type { Venda, VendaParcela, VendaDesconto, CancelarVendaCommand } from '@/domain/model/Venda';
import type { Page } from '@/domain/model/Page';
import type { VendaGateway, ListVendasParams } from '@/application/port/out/VendaGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/vendas';

export class HttpVendaGateway implements VendaGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: ListVendasParams): Promise<Page<Venda>> {
    const params: Record<string, string | number> = {};
    if (p.status) params['status'] = p.status;
    if (p.alunoId) params['alunoId'] = p.alunoId;
    if (p.vendedorUserId) params['vendedorUserId'] = p.vendedorUserId;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<Venda>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<Venda> {
    const res = await this.client<ApiResponse<Venda>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async listParcelas(id: string): Promise<VendaParcela[]> {
    const res = await this.client<ApiResponse<VendaParcela[]>>(`${PATH}/${encodeURIComponent(id)}/parcelas`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async listDescontos(id: string): Promise<VendaDesconto[]> {
    const res = await this.client<ApiResponse<VendaDesconto[]>>(`${PATH}/${encodeURIComponent(id)}/descontos`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async cancelar(id: string, command: CancelarVendaCommand): Promise<Venda> {
    const res = await this.client<ApiResponse<Venda>>(
      `${PATH}/${encodeURIComponent(id)}/cancelar`,
      { method: 'POST', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
